module.exports = __webpack_public_path__ + "img/menu-camera.5c37c6c6.svg";